var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoCollection = function SvgIcoCollection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (/*#__PURE__*/React.createElement("svg", _extends({
      width: 48,
      height: 48,
      viewBox: "0 0 48 48",
      fill: "none",
      ref: svgRef
    }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M32.7 13.9V10.2C32.7 7.89262 31.7834 5.67974 30.1518 4.04817C28.5203 2.4166 26.3074 1.5 24 1.5C21.6926 1.5 19.4797 2.4166 17.8482 4.04817C16.2166 5.67974 15.3 7.89262 15.3 10.2V13.9H5V45H43V13.9H32.7ZM18.3 10.2C18.3 8.68827 18.9005 7.23845 19.9695 6.16949C21.0384 5.10053 22.4883 4.5 24 4.5C25.5117 4.5 26.9616 5.10053 28.0305 6.16949C29.0995 7.23845 29.7 8.68827 29.7 10.2V13.9H18.3V10.2ZM40 42H8V16.9H15.3V19.4C15.3 19.7978 15.458 20.1794 15.7393 20.4607C16.0206 20.742 16.4022 20.9 16.8 20.9C17.1978 20.9 17.5794 20.742 17.8607 20.4607C18.142 20.1794 18.3 19.7978 18.3 19.4V16.9H29.7V19.4C29.7 19.7978 29.858 20.1794 30.1393 20.4607C30.4206 20.742 30.8022 20.9 31.2 20.9C31.5978 20.9 31.9794 20.742 32.2607 20.4607C32.542 20.1794 32.7 19.7978 32.7 19.4V16.9H40V42Z",
      fill: "currentColor"
    })))
  );
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (/*#__PURE__*/React.createElement(SvgIcoCollection, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ico_collection.a6324a61.svg";
export { ForwardRef as ReactComponent };